import { useEffect, useState } from 'react';
import { type Session, getSession, onSessionChange } from '../lib/session';

export function useSession(): Session | null {
  const [session, setSession] = useState<Session | null>(() => getSession());
  useEffect(() => onSessionChange(setSession), []);
  return session;
}
